<p-dialog header='Сводный протокол лич. результатов "{{selectedClass.name}}"' *ngIf="userform" [(visible)]="visibleDialog"
  [modal]="true" [responsive]="true" [style]="{width: '550px', minWidth: '200px'}" (onHide)="closeEvent.emit()">
  <form [formGroup]="userform">
    <p-fieldset legend="1 Заезд" class="ui-g-12">
      <div class="ui-g">
        <div class="ui-g-nopad ui-g-12 label">
          <div class="ui-g-3 label_row">
            <label><b>Дата:</b></label>
          </div>
          <div class="ui-g-9">
            <p-calendar formControlName="date_1" [showIcon]="true" dateFormat="dd.mm.yy" (onSelect)="selectDay(userform.get('date_1')?.value, '1')"
              (onMonthChange)="changeMonth($event)" appendTo="body">
              <ng-template pTemplate="date" let-date_1>
                <span
                  [ngStyle]="{backgroundColor: (dates[date_1.year] != null && dates[date_1.year][date_1.month] != null && dates[date_1.year][date_1.month][date_1.day] != null) ? '#81C784' : 'inherit'}"
                  style="border-radius:100%;padding: .25em;width: 1.75em; height:1.75em; display:block;">{{date_1.day}}
                  <div class="count_races"
                    *ngIf="(dates[date_1.year] != null && dates[date_1.year][date_1.month] != null && dates[date_1.year][date_1.month][date_1.day] != null)">
                    {{ dates[date_1.year][date_1.month][date_1.day].length }}</div>
                </span>
              </ng-template>
            </p-calendar>
          </div>
        </div>
        <div class="ui-g-nopad ui-g-12 label" *ngIf="selectedRace_1">
          <div class="ui-g-3 label_row">
            <label><b>Гонка:</b></label>
          </div>
          <div [ngClass]="{'ui-g-9':!not_found && !loading, 'ui-g-8': not_found || loading}">
            <!-- {{year_1 }} - {{ month_1}} - {{ day_1}} -->
            <p-dropdown [options]="dates[year_1][month_1][day_1]" formControlName="selectedRace_1" (onChange)="checkClass()" dataKey="rUid" [disabled]="loading" optionLabel="name">
              <!-- Шаблон для отображения элементов в выпадающем списке -->
              <ng-template let-race optionLabel="name">
                  <div class="dropdown-item-content">
                      {{ race.name }}
                  </div>
              </ng-template>
              <!-- Шаблон для отображения выбранного элемента -->
              <ng-template let-selectedRace pTemplate="selectedItem">
                  <div class="dropdown-selected-item-content">
                      {{ selectedRace.name }}
                  </div>
              </ng-template>
            </p-dropdown>
          </div>
          <div class="ui-g-1" *ngIf="not_found && !loading"><i class="pi pi-ban" title="Не обнаружен совпадающий по названию класс" (click)="showMessage($event)" style="font-size: 31px;color: red;"></i></div>
          <div class="ui-g-1" *ngIf="loading"><i class="pi pi-spin pi-spinner" title="Загрузка" (click)="showMessage($event)" style="font-size: 31px;color: gray;"></i></div>
        </div>
      </div>
    </p-fieldset>
    <p-fieldset legend="2 Заезд (Текущая гонка)" class="ui-g-12">
      <div class="ui-g">
        <div class="ui-g-nopad ui-g-12 label">
          <div class="ui-g-3 label_row">
            <label><b>Дата:</b></label>
          </div>
          <div class="ui-g-9">
            <p-calendar [disabled]="true" formControlName="date_2" [showIcon]="true" dateFormat="dd.mm.yy"
              (onSelect)="selectDay(userform.get('date_2')?.value, '2')" (onMonthChange)="changeMonth($event)" appendTo="body">
              <ng-template pTemplate="date" let-date_2>
                <span
                  [ngStyle]="{backgroundColor: (dates[date_2.year] != null && dates[date_2.year][date_2.month] != null && dates[date_2.year][date_2.month][date_2.day] != null) ? '#81C784' : 'inherit'}"
                  style="border-radius:100%;padding: .25em;width: 1.75em; height:1.75em; display:block;">{{date_2.day}}
                  <div class="count_races"
                    *ngIf="(dates[date_2.year] != null && dates[date_2.year][date_2.month] != null && dates[date_2.year][date_2.month][date_2.day] != null)">
                    {{ dates[date_2.year][date_2.month][date_2.day].length }}</div>
                </span>
              </ng-template>
            </p-calendar>
          </div>
        </div>
        <div class="ui-g-nopad ui-g-12 label" *ngIf="selectedRace_2">
          <div class="ui-g-3 label_row">
            <label><b>Гонка:</b></label>
          </div>
          <div class="ui-g-9">
            <p-dropdown [disabled]="true" [options]="dates[year_2][month_2][day_2]" formControlName="selectedRace_2" dataKey="rUid" optionLabel="name">
              <!-- Шаблон для отображения элементов в выпадающем списке -->
              <ng-template let-race optionLabel="name">
                  <div class="dropdown-item-content">
                      {{ race.name }}
                  </div>
              </ng-template>
              <!-- Шаблон для отображения выбранного элемента -->
              <ng-template let-selectedRace pTemplate="selectedItem">
                  <div class="dropdown-selected-item-content">
                      {{ selectedRace.name }}
                  </div>
              </ng-template>              
            </p-dropdown>
          </div>
        </div>
      </div>
    </p-fieldset>
    <p-fieldset legend="*3 Заезд" class="ui-g-12">
      <div class="ui-g">
        <div class="ui-g-nopad ui-g-12 label">
          <div class="ui-g-3 label_row">
            <label><b>Дата:</b></label>
          </div>
          <div class="ui-g-9">
            <p-calendar formControlName="date_3" [showIcon]="true" dateFormat="dd.mm.yy" (onSelect)="selectDay(userform.get('date_3')?.value, '3')"
              (onMonthChange)="changeMonth($event)" appendTo="body">
              <ng-template pTemplate="date" let-date_3>
                <span
                  [ngStyle]="{backgroundColor: (dates[date_3.year] != null && dates[date_3.year][date_3.month] != null && dates[date_3.year][date_3.month][date_3.day] != null) ? '#81C784' : 'inherit'}"
                  style="border-radius:100%;padding: .25em;width: 1.75em; height:1.75em; display:block;">{{date_3.day}}
                  <div class="count_races"
                    *ngIf="(dates[date_3.year] != null && dates[date_3.year][date_3.month] != null && dates[date_3.year][date_3.month][date_3.day] != null)">
                    {{ dates[date_3.year][date_3.month][date_3.day].length }}</div>
                </span>
              </ng-template>
            </p-calendar>
          </div>
        </div>
        <div class="ui-g-nopad ui-g-12 label" *ngIf="selectedRace_3">
          <div class="ui-g-3 label_row">
            <label><b>Гонка:</b></label>
          </div>
          <div [ngClass]="{'ui-g-9':!not_found_3 && !loading, 'ui-g-8': not_found_3 || loading}">
            <p-dropdown [showClear]="true" [options]="dates[year_3][month_3][day_3]" formControlName="selectedRace_3" (onChange)="checkClass()" dataKey="rUid" [disabled]="loading" optionLabel="name" placeholder="Третий заезд (опционально)"></p-dropdown>
          </div>
          <div class="ui-g-1" *ngIf="not_found_3 && !loading"><i class="pi pi-ban" title="Не обнаружен совпадающий по названию класс" (click)="showMessage($event)" style="font-size: 31px;color: red;"></i></div>
          <div class="ui-g-1" *ngIf="loading"><i class="pi pi-spin pi-spinner" title="Загрузка" (click)="showMessage($event)" style="font-size: 31px;color: gray;"></i></div>
        </div>
      </div>
    </p-fieldset>
    <p-fieldset legend="*4 Заезд" class="ui-g-12">
      <div class="ui-g">
        <div class="ui-g-nopad ui-g-12 label">
          <div class="ui-g-3 label_row">
            <label><b>Дата:</b></label>
          </div>
          <div class="ui-g-9">
            <p-calendar formControlName="date_4" [showIcon]="true" dateFormat="dd.mm.yy" (onSelect)="selectDay(userform.get('date_4')?.value, '4')"
              (onMonthChange)="changeMonth($event)" appendTo="body">
              <ng-template pTemplate="date" let-date_4>
                <span
                  [ngStyle]="{backgroundColor: (dates[date_4.year] != null && dates[date_4.year][date_4.month] != null && dates[date_4.year][date_4.month][date_4.day] != null) ? '#81C784' : 'inherit'}"
                  style="border-radius:100%;padding: .25em;width: 1.75em; height:1.75em; display:block;">{{date_4.day}}
                  <div class="count_races"
                    *ngIf="(dates[date_4.year] != null && dates[date_4.year][date_4.month] != null && dates[date_4.year][date_4.month][date_4.day] != null)">
                    {{ dates[date_4.year][date_4.month][date_4.day].length }}</div>
                </span>
              </ng-template>
            </p-calendar>
          </div>
        </div>
        <div class="ui-g-nopad ui-g-12 label" *ngIf="selectedRace_4">
          <div class="ui-g-3 label_row">
            <label><b>Гонка:</b></label>
          </div>
          <div [ngClass]="{'ui-g-9':!not_found_4 && !loading, 'ui-g-8': not_found_4 || loading}">
            <p-dropdown [showClear]="true" [options]="dates[year_4][month_4][day_4]" formControlName="selectedRace_4" (onChange)="checkClass()" dataKey="rUid" [disabled]="loading" optionLabel="name" placeholder="Четвертый заезд (опционально)"></p-dropdown>
          </div>
          <div class="ui-g-1" *ngIf="not_found_4 && !loading"><i class="pi pi-ban" title="Не обнаружен совпадающий по названию класс" (click)="showMessage($event)" style="font-size: 31px;color: red;"></i></div>
          <div class="ui-g-1" *ngIf="loading"><i class="pi pi-spin pi-spinner" title="Загрузка" (click)="showMessage($event)" style="font-size: 31px;color: gray;"></i></div>
        </div>
      </div>
    </p-fieldset>
    <p-fieldset legend="*5 Заезд" class="ui-g-12">
      <div class="ui-g">
        <div class="ui-g-nopad ui-g-12 label">
          <div class="ui-g-3 label_row">
            <label><b>Дата:</b></label>
          </div>
          <div class="ui-g-9">
            <p-calendar formControlName="date_5" [showIcon]="true" dateFormat="dd.mm.yy" (onSelect)="selectDay(userform.get('date_5')?.value, '5')"
              (onMonthChange)="changeMonth($event)" appendTo="body">
              <ng-template pTemplate="date" let-date_5>
                <span
                  [ngStyle]="{backgroundColor: (dates[date_5.year] != null && dates[date_5.year][date_5.month] != null && dates[date_5.year][date_5.month][date_5.day] != null) ? '#81C784' : 'inherit'}"
                  style="border-radius:100%;padding: .25em;width: 1.75em; height:1.75em; display:block;">{{date_5.day}}
                  <div class="count_races"
                    *ngIf="(dates[date_5.year] != null && dates[date_5.year][date_5.month] != null && dates[date_5.year][date_5.month][date_5.day] != null)">
                    {{ dates[date_5.year][date_5.month][date_5.day].length }}</div>
                </span>
              </ng-template>
            </p-calendar>
          </div>
        </div>
        <div class="ui-g-nopad ui-g-12 label" *ngIf="selectedRace_5">
          <div class="ui-g-3 label_row">
            <label><b>Гонка:</b></label>
          </div>
          <div [ngClass]="{'ui-g-9':!not_found_5 && !loading, 'ui-g-8': not_found_5 || loading}">
            <p-dropdown [showClear]="true" [options]="dates[year_5][month_5][day_5]" formControlName="selectedRace_5" (onChange)="checkClass()" dataKey="rUid" [disabled]="loading" optionLabel="name" placeholder="Пятый заезд (опционально)"></p-dropdown>
          </div>
          <div class="ui-g-1" *ngIf="not_found_5 && !loading"><i class="pi pi-ban" title="Не обнаружен совпадающий по названию класс" (click)="showMessage($event)" style="font-size: 31px;color: red;"></i></div>
          <div class="ui-g-1" *ngIf="loading"><i class="pi pi-spin pi-spinner" title="Загрузка" (click)="showMessage($event)" style="font-size: 31px;color: gray;"></i></div>
        </div>
      </div>
    </p-fieldset>
    <p-fieldset legend="*6 Заезд" class="ui-g-12">
      <div class="ui-g">
        <div class="ui-g-nopad ui-g-12 label">
          <div class="ui-g-3 label_row">
            <label><b>Дата:</b></label>
          </div>
          <div class="ui-g-9">
            <p-calendar formControlName="date_6" [showIcon]="true" dateFormat="dd.mm.yy" (onSelect)="selectDay(userform.get('date_6')?.value, '6')"
              (onMonthChange)="changeMonth($event)" appendTo="body">
              <ng-template pTemplate="date" let-date_6>
                <span
                  [ngStyle]="{backgroundColor: (dates[date_6.year] != null && dates[date_6.year][date_6.month] != null && dates[date_6.year][date_6.month][date_6.day] != null) ? '#81C784' : 'inherit'}"
                  style="border-radius:100%;padding: .25em;width: 1.75em; height:1.75em; display:block;">{{date_6.day}}
                  <div class="count_races"
                    *ngIf="(dates[date_6.year] != null && dates[date_6.year][date_6.month] != null && dates[date_6.year][date_6.month][date_6.day] != null)">
                    {{ dates[date_6.year][date_6.month][date_6.day].length }}</div>
                </span>
              </ng-template>
            </p-calendar>
          </div>
        </div>
        <div class="ui-g-nopad ui-g-12 label" *ngIf="selectedRace_6">
          <div class="ui-g-3 label_row">
            <label><b>Гонка:</b></label>
          </div>
          <div [ngClass]="{'ui-g-9':!not_found_6 && !loading, 'ui-g-8': not_found_6 || loading}">
            <p-dropdown [showClear]="true" [options]="dates[year_6][month_6][day_6]" formControlName="selectedRace_6" (onChange)="checkClass()" dataKey="rUid" [disabled]="loading" optionLabel="name" placeholder="Шестой заезд (опционально)"></p-dropdown>
          </div>
          <div class="ui-g-1" *ngIf="not_found_6 && !loading"><i class="pi pi-ban" title="Не обнаружен совпадающий по названию класс" (click)="showMessage($event)" style="font-size: 31px;color: red;"></i></div>
          <div class="ui-g-1" *ngIf="loading"><i class="pi pi-spin pi-spinner" title="Загрузка" (click)="showMessage($event)" style="font-size: 31px;color: gray;"></i></div>
        </div>
      </div>
    </p-fieldset>
    <div class="ui-g-12">
      <ng-container *ngIf="score$ | async as score">
        <p-dropdown class="ui-lg-6 ui-g-6 ui-md-4" [options]="score" formControlName="score"
          placeholder="Таблица очков*" optionLabel="tableName" [showClear]="true" appendTo="body"></p-dropdown>
      </ng-container>
      <ng-container *ngIf="scores_equal$ | async as scores_equal">
        <p-dropdown class="ui-lg-6 ui-g-6 ui-md-4" [options]="scores_equal" formControlName="scores_equal"
          placeholder="При равенстве очков*" optionLabel="equalScoresVariantName" [showClear]="true" appendTo="body">
      </p-dropdown>
      </ng-container>
      <p-button (onClick)="onSubmit()" class="ui-lg-12 ui-g-12 ui-md-4 ui-sm-12 m-1" label="Сформировать" icon="pi pi-file"></p-button>
      <p-button (onClick)="onSubmit(true)" class="ui-lg-12 ui-g-12 ui-md-4 ui-sm-12 m-1" label="Выгрузить csv" icon="pi pi-download"></p-button>
    </div>
  </form>
</p-dialog>